import { Stack, styled } from '@mui/material'

export const StyledResource = styled(Stack)(({ theme }) => ({
  border: '1px gray solid',
  borderRadius: '8px',
  maxWidth: '300px',
  margin: theme.spacing(0, 'auto', 2),
	padding:"40px 20px 20px",
  '.text': {
    padding: theme.spacing(2),
	  marginTop:0,
    textAlign: 'center',
    alignItems: 'center',
  },
	
	'.MuiStack-root.text.with-margin':{margin:'auto'},

  [theme.breakpoints.up('md')]: {
	  padding:"40px 20px 40px 40px",
    margin: theme.spacing(0, 'auto', 4),
    maxWidth: 'unset',
    '.responsive-image picture': {
      display: 'inline-block',
    },
    '.text': {
      padding: theme.spacing(2, 0, 2, 0),
      textAlign: 'left',
      alignItems: 'unset',
    },
	 '.MuiStack-root.text.with-margin':{margin:'40px'},   
  },
}))
